export default __webpack_public_path__ + "static/media/Free and easy.a989d96e.jpg";